module.exports = __webpack_public_path__ + "BXUbzhP6_400x400.webp?b2b268a75c5a9ac5414e351a4c63a721";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/BXUbzhP6_400x400.webp
// module id = 50
// module chunks = 0